import axios from 'axios';

import { InternalAxiosRequestConfig } from 'axios';

import * as storageLocale from 'i18n/storageLocale';
import config from 'config';
import { getAccessToken } from 'common/utils/auth/accessToken';

const headers = {
  'Accept-Language': storageLocale.getLocale(),
  'Content-Type': 'application/json',
  ...config.territory && { territory: config.territory }
}

export const locatorServiceAPI = axios.create({
  baseURL: config.serviceName,
  headers
});

export const locatorSSServiceAPI = axios.create({
  baseURL: config.authServiceName,
  headers
});

const requestHandle = (config: InternalAxiosRequestConfig<any>) => {
  const accessToken = getAccessToken();

  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }

  return config;
}

locatorServiceAPI.interceptors.request.use(requestHandle);
locatorSSServiceAPI.interceptors.request.use(requestHandle);
